import React, { createContext } from 'react';
import { initModalsData, useCreateModalsForContext } from './useCreateModalsForContext';
import { Modals } from '../types';
export const initialModalContextValues = {
  activeModal: Modals.loading,
  setActiveModal: () => {},
  modals: initModalsData,
  hideModalOverlay: false
};
export const ModalsContext = /*#__PURE__*/createContext(initialModalContextValues);
export const ModalsContextProvider = _ref => {
  let {
    children,
    onInstallationCompleted,
    hideModalOverlay = false
  } = _ref;
  const [activeModal, setActiveModal] = React.useState(Modals.none);
  const modals = useCreateModalsForContext({
    setActiveModal,
    onInstallationCompleted
  });
  return /*#__PURE__*/React.createElement(ModalsContext.Provider, {
    value: {
      activeModal,
      setActiveModal,
      modals,
      hideModalOverlay
    }
  }, children);
};
export const useModals = () => React.useContext(ModalsContext);
//# sourceMappingURL=ModalsContext.js.map